/**
 * QR Code + CD Insert API Service
 * Migrated from 3in1cms legacy/qrCdInsertApi.ts
 */

import { request } from "../core/request";
import { EVENT_CODE, OPERATION_IDS } from "./constants";

export interface IQRCDInsertData {
  businessType?: string;
  mobileNo?: string;
  reKYCFlag?: string;
  customerType?: string;
  dealerId?: string;
  pincode?: string;
  cardNumber?: string;
  journeyName?: string;
  id?: string;
  eventCode?: string;
}

export interface IQRCDInsertRequest extends IQRCDInsertData {
  utmContent?: string;
  utmSource?: string;
  utmCampaign?: string;
  utmMedium?: string;
}

export interface IQRCDInsertResponse {
  id: string;
  description: string;
  statusCode: string;
  txId: string;
  dbResponse: string;
  eventCode: string;
}

/**
 * Extract numeric characters from dealer ID
 * @param dealerId - Dealer ID string
 * @returns Numeric-only dealer ID
 */
const extractNumericFromDealerId = (dealerId: string): string => {
  return dealerId.replace(/\D/g, "");
};

/**
 * Insert QR CD data
 * @param data - QR CD insert data
 * @returns QR CD insert response or null on error
 */
export const qrCdInsert = async (data: IQRCDInsertData): Promise<IQRCDInsertResponse | null> => {
  try {
    const numericDealerId = extractNumericFromDealerId(data?.dealerId ?? "");

    const reqData: IQRCDInsertRequest = {
      businessType: data?.businessType,
      mobileNo: data?.mobileNo,
      reKYCFlag: data?.reKYCFlag,
      customerType: data?.customerType,
      dealerId: numericDealerId,
      pincode: data?.pincode,
      cardNumber: data?.cardNumber,
      journeyName: "QR_CD",
      eventCode: EVENT_CODE.QR_PDP_INSERT,
      id: data?.id ?? "",
    };

    const response = (await request<IQRCDInsertResponse, IQRCDInsertRequest>({
      operationId: OPERATION_IDS.qrCdInsert,
      requestData: { ...reqData },
    })) as IQRCDInsertResponse;

    return response;
  } catch (error) {
    console.error("Error in qrCdInsert", error);
    return null;
  }
};
